var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgHomeDashboard(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M13.333 4H4v9.333h9.333V4zM28 4h-9.333v9.333H28V4zM28 18.667h-9.333V28H28v-9.333zM13.333 18.667H4V28h9.333v-9.333z",
    fill: "#EDE3F3"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M13.333 4H4v9.333h9.333V4zM28 4h-9.333v9.333H28V4zM28 18.667h-9.333V28H28v-9.333zM13.333 18.667H4V28h9.333v-9.333z",
    stroke: "#500D76",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHomeDashboard);
export default __webpack_public_path__ + "static/media/homeDashboard.43c3184b232f56ffe7c8864a31c1219d.svg";
export { ForwardRef as ReactComponent };